"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _marketingCommodity = require("@/api/marketingFunction/marketingCommodity");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketingEvents',
  data: function data() {
    return {
      options: [],
      activeName: 'first',
      queryData: {
        status: 1,
        goodsId: '',
        title: '',
        activityId: '',
        page: {
          page: 1,
          size: 10
        }
      },
      tableData: [],
      total: 0,
      // 条数

      eventsType: 'add',
      // 编辑and新增
      dialogVisible: false,
      ruleForm: {
        id: null,
        platformCode: '',
        goodsId: '',
        activityId: null,
        subsidyAmt: '',
        timeArray: [],
        subsidyStartTime: null,
        subsidyEndTime: null,
        goodsStatus: null
      },
      rules: {
        platformCode: [{
          required: true,
          message: '请选择商品类型',
          trigger: 'change'
        }],
        goodsId: [{
          required: true,
          message: '请输入商品ID',
          trigger: 'blur'
        }],
        activityId: [{
          required: true,
          message: '请选择所属活动',
          trigger: 'change'
        }],
        subsidyAmt: [{
          required: true,
          message: '请输入礼金额',
          trigger: 'blur'
        }],
        goodsStatus: [{
          required: true,
          message: '请选择商品状态',
          trigger: 'change'
        }],
        timeArray: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }]
      },
      ProductDetails: {}
    };
  },
  created: function created() {
    this.productAll();
    this.productList();
  },
  methods: {
    // 置顶商品  pinned 0未置顶
    portalGoodsTop: function () {
      var _portalGoodsTop2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(id, status) {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                id: id,
                status: status
              };
              _context.n = 1;
              return (0, _marketingCommodity.portalGoodsTop)(params);
            case 1:
              res = _context.v;
              if (res.data) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                // this.onInitialize()
                this.productList();
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function portalGoodsTop(_x, _x2) {
        return _portalGoodsTop2.apply(this, arguments);
      }
      return portalGoodsTop;
    }(),
    oNPinned: function oNPinned(data) {
      var _this = this;
      this.$confirm('是否确认置顶商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.portalGoodsTop(data.id, 1);
      });
    },
    onUnTop: function onUnTop(data) {
      var _this2 = this;
      this.$confirm('是否确认取消置顶商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.portalGoodsTop(data.id, 0);
      });
    },
    productAll: function () {
      var _productAll2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {};
              _context2.n = 1;
              return (0, _marketingCommodity.productAll)(params);
            case 1:
              res = _context2.v;
              this.options = res.data;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function productAll() {
        return _productAll2.apply(this, arguments);
      }
      return productAll;
    }(),
    productList: function () {
      var _productList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context3.n = 1;
              return (0, _marketingCommodity.productList)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function productList() {
        return _productList2.apply(this, arguments);
      }
      return productList;
    }(),
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.productList();
    },
    onInitialize: function onInitialize() {
      this.queryData.goodsId = '';
      this.queryData.title = '';
      this.queryData.activityId = '';
      this.queryData.page = {
        page: 1,
        size: 10
      };
      this.productList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.productList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.productList();
    },
    // 添加-------------
    onAdd: function onAdd() {
      this.eventsType = 'add';
      this.dialogVisible = true;
    },
    // productGetGoodsDetailById
    // 商品详情
    productGetGoodsDetailById: function () {
      var _productGetGoodsDetailById2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(platformCode, goodsId) {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                platformCode: platformCode,
                goodsId: goodsId
              };
              _context4.n = 1;
              return (0, _marketingCommodity.productGetGoodsDetailById)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.ProductDetails = res.data;
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function productGetGoodsDetailById(_x3, _x4) {
        return _productGetGoodsDetailById2.apply(this, arguments);
      }
      return productGetGoodsDetailById;
    }(),
    // 保存接口
    productSave: function () {
      var _productSave2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              this.ruleForm.subsidyStartTime = this.ruleForm.timeArray[0];
              this.ruleForm.subsidyEndTime = this.ruleForm.timeArray[1];
              delete this.resetForm.timeArray;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context5.n = 1;
              return (0, _marketingCommodity.productSave)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.$message({
                  message: '新增成功',
                  type: 'success'
                });
                this.handleClose();
                this.productList();
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function productSave() {
        return _productSave2.apply(this, arguments);
      }
      return productSave;
    }(),
    // 编辑接口
    productUpdate: function () {
      var _productUpdate2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              this.ruleForm.subsidyStartTime = this.ruleForm.timeArray[0];
              this.ruleForm.subsidyEndTime = this.ruleForm.timeArray[1];
              delete this.resetForm.timeArray;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context6.n = 1;
              return (0, _marketingCommodity.productUpdate)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                });
                this.handleClose();
                this.productList();
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              console.log(_t6);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function productUpdate() {
        return _productUpdate2.apply(this, arguments);
      }
      return productUpdate;
    }(),
    onShare: function onShare(platformCode, goodsId) {
      if (goodsId === '') {
        return this.$message({
          type: 'warning',
          message: '请先输入商品ID!'
        });
      }
      if (platformCode === '') {
        return this.$message({
          type: 'warning',
          message: '请先选择商品类型!'
        });
      }
      this.productGetGoodsDetailById(platformCode, goodsId);
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.$confirm("\u662F\u5426\u786E\u8BA4".concat(_this3.eventsType === 'add' ? '添加' : '编辑', "\u6B64\u5546\u54C1?"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            if (_this3.eventsType === 'add') {
              _this3.productSave();
            } else {
              _this3.productUpdate();
            }
          });
        } else {
          return false;
        }
      });
    },
    initRuleForm: function initRuleForm() {
      this.ruleForm = {
        id: null,
        platformCode: '',
        goodsId: '',
        activityId: null,
        subsidyAmt: '',
        timeArray: [],
        subsidyStartTime: null,
        subsidyEndTime: null,
        goodsStatus: null
      };
    },
    resetForm: function resetForm(formName) {
      this.initRuleForm();
      this.ProductDetails = {};
      this.$refs[formName].resetFields();
    },
    handleClose: function handleClose() {
      this.resetForm('ruleForm');
      this.dialogVisible = false;
      this.ProductDetails = {};
    },
    handleClick: function handleClick(tab, event) {
      if (tab.label === '上架商品') {
        this.queryData.status = 1;
      } else {
        this.queryData.status = 0;
      }
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.productList();
    },
    // 编辑
    onEditor: function onEditor(data) {
      this.eventsType = 'editor';
      this.ruleForm.id = data.id;
      this.ruleForm.platformCode = data.platformCode;
      this.ruleForm.goodsId = data.goodsId;
      this.ruleForm.activityId = data.activityId;
      this.ruleForm.subsidyAmt = data.subsidyAmt;
      if (data.subsidyStartTime) {
        this.ruleForm.timeArray = [data.subsidyStartTime, data.subsidyEndTime];
      }
      this.ruleForm.goodsStatus = data.goodsStatus;
      this.dialogVisible = true;
    },
    // 删除
    onDel: function onDel(data) {
      var _this4 = this;
      this.$confirm("\u662F\u5426\u786E\u8BA4\u5220\u9664\u6B64\u5546\u54C1?", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.productDeleteById(data.id);
      });
    },
    productDeleteById: function () {
      var _productDeleteById2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7(id) {
        var params, res, _t7;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              params = {
                id: id
              };
              _context7.n = 1;
              return (0, _marketingCommodity.productDeleteById)(params);
            case 1:
              res = _context7.v;
              if (res.code === 0) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.productList();
              }
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t7 = _context7.v;
              console.log(_t7);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function productDeleteById(_x5) {
        return _productDeleteById2.apply(this, arguments);
      }
      return productDeleteById;
    }(),
    // 同步
    onSynchronization: function onSynchronization() {
      var _this5 = this;
      this.$confirm("\u662F\u5426\u786E\u8BA4\u540C\u6B65\u5546\u54C1\u4FE1\u606F?", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.productRefGoods();
      });
    },
    productRefGoods: function () {
      var _productRefGoods2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8(id) {
        var params, res, _t8;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              params = {
                id: id
              };
              _context8.n = 1;
              return (0, _marketingCommodity.productRefGoods)(params);
            case 1:
              res = _context8.v;
              if (res.code === 0) {
                this.$message({
                  message: '同步商品信息成功',
                  type: 'success'
                });
                this.productList();
              }
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t8 = _context8.v;
              console.log(_t8);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function productRefGoods(_x6) {
        return _productRefGoods2.apply(this, arguments);
      }
      return productRefGoods;
    }()
  }
};